import React from 'react';
import InfoNotification from '../../InfoNotification';
import {ServerNotificationProps} from '../ServerNotification';
import {INotificationProps} from '@src/@interfaces/components/Notifications/INotificationProps';
import app from '@src/helpers/app';
import CommentInline from '@src/components/CommentsList/CommentInline';
import makeUrl from '@src/components/Notifications/server-notifications/makeUrl';
import getDashboardEndpoint from '@src/components/Notifications/server-notifications/Order/getDashboardEndpoint';

export default class CommentAdded extends InfoNotification<
        ServerNotificationProps<'App\\Notifications\\Order\\CommentAdded'> &
        INotificationProps
> {
    protected getWrapperTagProps(): any {
        const payload = this.props.notification.data;
        const namesResolver = app('names-resolver').clientRoutes;

        return {
            ...super.getWrapperTagProps(),
            to: makeUrl({
                uriItems: [
                    getDashboardEndpoint('manager-order-page', payload.orderId),
                    {
                        route: namesResolver.getShowRouteName('Orders'),
                        params: {id: String(payload.orderId)},
                    }
                ],
                searchParams: {
                    commentId: payload.comment.id,
                },
                hash: '#OrdersShow.tabs.comments'
            }),
        };
    }

    protected renderMessage() {
        return <CommentInline
                model={this.props.notification.data.comment}
                allowToDelete={false}
                allowToReply={false}
                allowHighlight={false}
        />;
    }
}
